import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { Component, Inject, Input, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ApiCallService } from "src/app/core/services/api-call-service";

/*
 * Each node has a name and an optiona list of children.
 */
interface FoodNode {
  name: string;
  id?: number;
  selected?: boolean;
  indeterminate?: boolean;
  children?: FoodNode[];
  ok?: boolean;
}

/*
 * @title Tree with nested nodes
 */
@Component({
  selector: "app-offer-add-product-dialog",
  templateUrl: "./offer-add-product-dialog.component.html",
  styleUrls: ["./offer-add-product-dialog.component.css"],
})
export class OfferAddProductDialogComponent implements OnInit {
  treeControl = new NestedTreeControl<FoodNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  loading = false;
  databean;
  search;


  apiProductList=[]
  fullproductListLength;
  productType=[];

  currentSelection=[];


  @Input() dataSelectorBean: any;
  constructor( private apiCall:ApiCallService,
    public dialogRef: MatDialogRef<OfferAddProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public initialDatabean
  ) {



  }
  ngOnInit() {
    this.databean = JSON.parse(JSON.stringify(this.initialDatabean));
    this.loading = true;
    this.dataSource.data = this.databean.totalProducts;
    this.loading = false;
    var k = this.databean.selectedProductList.map((x) => x.id);
    Object.keys(this.dataSource.data).forEach((x) => {
      this.setParent(this.dataSource.data[x], null, k);
    });
  }

  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;

  setParent(data, parent, k) {
    data.parent = parent;
    if (data.children) {
      data.children.forEach((x) => {
        if (k.includes(x.id)) {
          x.selected = true;
        } else {
          x.selected = false;
        }
        this.setParent(x, data, k);
      });
    }
  }

  checkAllParents(node) {
    if (node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent);
      node.parent.selected = descendants.every((child) => child.selected);
      node.parent.indeterminate = descendants.some((child) => child.selected);
      this.checkAllParents(node.parent);
    }
  }
  todoItemSelectionToggle(checked, node) {
    node.selected = checked;
    if (node.children) {
      node.children.forEach((x) => {
        this.todoItemSelectionToggle(checked, x);
      });
    }
    this.checkAllParents(node);
  }

  setChildOk(text: string, node: any) {
    node.forEach((x) => {
      x.ok = x.name.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      if (x.parent) this.setParentOk(text, x.parent, x.ok);
      if (x.children) this.setChildOk(text, x.children);
    });
  }
  setParentOk(text, node, ok) {
    node.ok = ok || node.ok || node.name.indexOf(text) >= 0;
    if (node.parent) this.setParentOk(text, node.parent, node.ok);
  }

  submit() {
    let result = [];
    let resultArray = [];
    this.dataSource.data.forEach((node) => {
      let parentNodeName = node.name;

      result = result.concat(
        this.treeControl.getDescendants(node).filter(function (x) {
          if (x.selected && x.id) {
            resultArray.push({
              id: x.id,
              name:
                parentNodeName == x.name
                  ? x.name
                  : parentNodeName + "(" + x.name + ")",
            });
          }
        })
      );
    });

    this.save(resultArray, this.dataSource.data);
  }
  //For check the values
  getList2(node: any, result: any = null) {
    result = result || {};
    node.forEach((x) => {
      result[x.name] = {};
      result[x.name].ok = x.ok;
      if (x.children) result[x.name].children = this.getList2(x.children);
    });
    return result;
  }
  //Another way to check the values, we can not use {{datasource.node}}
  getList(node: any) {
    return node.map((x) => {
      const r: any = {
        name: x.name + " - " + x.ok,
        children: x.children ? this.getList(x.children) : null,
      };
      if (!r.children) delete r.children;
      return r;
    });
  }
  save(variantIdOnlyArray, data) {
    let k = { variantIdArray: variantIdOnlyArray, dataSource: data };
    this.dialogRef.close(k);
  }

  previousData = ""; // create a property which will track of previous data from parent component.

  getInputField(data) {
    if (data && data.length >= 3 && data.length > this.previousData.length) {
      this.getProduct(data);
      //this.myService.getDataFromService(dat a).subscribe(rs=>console.log(rs));
    }
    this.previousData = data || ""; // update previous data to current data after backend call.
  }

  getProduct(char) {
    this.apiCall
      .getOfferManagementProductsList(char, 1, 50)
      .subscribe((resultList) => {
        this.apiProductList = (resultList["body"]);
        this.fullproductListLength = this.apiProductList.length;
        for (let i = 0; i < this.apiProductList.length; i++) {
          let k = [],
            selected = 0,
            parentProductGFId = null;
          for (let j = 0; j < this.apiProductList[i].variants.length; j++) {
            k.push({
              name: this.apiProductList[i].variants[j].variantName,
              id: this.apiProductList[i].variants[j].gfId,
              productId: this.apiProductList[i].variants[j].variantId,
              selected: false,
              //expandable:false
            });
          }
          this.productType.push({
            name: this.apiProductList[i].productName,
            id: this.apiProductList[i].gfId,
            productId: this.apiProductList[i].productId,
            children: k.length == 0 ? null : k,
            selected: false,
          });
        }
        this.databean.totalProducts = this.productType;
        this.dataSource.data = this.databean.totalProducts;
        this.loading = false;
        var k = this.databean.selectedProductList.map((x) => x.id);
        Object.keys(this.dataSource.data).forEach((x) => {
          this.setParent(this.dataSource.data[x], null, k);
        });

      });
  }

  compareArrayandDeDuplicate(array1,array2){
    return (array1.concat(array2).unique());
  }
}
/**  Copyright 2019 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
